import type { IconSvgObject } from './types';

const CampfireIcon: IconSvgObject = [
  ["path", { d: "M6 16C6 16 5 14.5 5 12C5 8 6.5 7 6.5 7C7.5 9 8.5 9 8.5 9C8.5 4 12 2 12 2C12 2 15.5 4 15.5 9C15.5 9 16.5 9 17.5 7C17.5 7 19 8 19 12C19 14.5 18 16 18 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 19H4V22H20V19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 16C14.5 13 12 11 12 11C12 11 9.5 13 9.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CampfireIcon;
